import React from 'react';
import classNames from 'classnames';
import { Spin as AntdLoading } from 'antd';
import { ConfigContext } from '../config-provider';
import { tuple } from '../_util/type';
import { PresetColorTypes } from '../_util/colors';
const LoadingSizes = tuple('small', 'default', 'large', 'xl');
export const Loading = (props) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className, size = 'default', indicator, type = 'circle', color, ...otherProps } = props;
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
    let LoadingColor = !color ? '' : color.toLocaleLowerCase().replace(/\s/g, '-');
    const isPresetColor = () => {
        if (!color) {
            return false;
        }
        return PresetColorRegex.test(LoadingColor) || LoadingColor === 'white';
    };
    const mergecolor = isPresetColor() ? LoadingColor : 'primary';
    const lineIndictor = (React.createElement("div", { className: 'loading-line' },
        React.createElement("div", { className: 'loading-line-bg' })));
    //不同尺寸circle
    let circleSize, circleWidth;
    switch (size) {
        case 'default':
            circleSize = 16;
            circleWidth = 2;
            break;
        case 'xl':
            circleSize = 40;
            circleWidth = 5;
            break;
        case 'large':
            circleSize = 24;
            circleWidth = 3;
            break;
        case 'small':
            circleSize = 12;
            circleWidth = 1.5;
            break;
    }
    const LoadingCircle = (circleSize, circleWidth) => (React.createElement("svg", { width: '100%', height: '100%', className: 'loading-svg', xmlns: 'https://www.w3.org/2000/svg' },
        React.createElement("circle", { r: circleSize / 2 - circleWidth, cy: circleSize / 2, cx: circleSize / 2, strokeWidth: circleWidth, stroke: `url(#linearGradient-${mergecolor})`, fill: 'none', strokeDasharray: '100%', strokeLinecap: 'round' }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: `linearGradient-${mergecolor}`, x1: '0%', y1: '100%', x2: '90%', y2: '0%' },
                React.createElement("stop", { className: 'stop1', stopColor: '#1b58f4', offset: '0%' }),
                React.createElement("stop", { className: 'stop2', stopColor: '#1b58f4', stopOpacity: '0', offset: '100%' })))));
    let loadingIndicator;
    if (!indicator) {
        loadingIndicator = type === 'circle' ? LoadingCircle(circleSize, circleWidth) : lineIndictor;
    }
    else {
        loadingIndicator = indicator;
    }
    const newClassName = classNames({
        [`${prefixCls}-xl`]: size === 'xl',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-md`]: size === 'default',
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-line`]: type === 'line',
        [`${prefixCls}-${mergecolor}`]: mergecolor
    }, className);
    if (size === 'small' || size === 'large' || size === 'default') {
        return (React.createElement(AntdLoading, { ...otherProps, prefixCls: prefixCls, className: newClassName, indicator: loadingIndicator, size: size }));
    }
    return (React.createElement(AntdLoading, { prefixCls: prefixCls, ...otherProps, className: newClassName, indicator: loadingIndicator }));
};
// export default withConfigProvider(Loading);
export default Loading;
